var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-screen-cover has-z-maximum is-centered is-semi-transparent is-pointerless has-background-black"},[_vm._t("default",function(){return [(_vm.value)?_c('label',{staticClass:"is-size-1 has-text-info has-text-weight-bold"},[_vm._v("\n\t\t\t"+_vm._s(_vm.value)+"\n\t\t")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }